import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@readsavor/api-client';
import { userQueryKeys } from './useUser';
/**
 * Hook for user login.
 * Handles the mutation for signing in a user and invalidates the user query on success.
 */
export const useLogin = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (credentials) => apiClient.auth.login(credentials),
        onSuccess: () => {
            // On successful login, invalidate the user query to refetch user data.
            queryClient.invalidateQueries({ queryKey: userQueryKeys.all });
        },
    });
};
//# sourceMappingURL=useLogin.js.map